// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;



const settings = {
    isOpenClass: 'is-open-navbar-offcanvas',
    isLoadingClass: 'is-loading',
    openSelectors: '.js-header-search-trigger', // jquery selector (string), separate with a ", " all the selectors that should open this.
    closeSelectors: '.js-header-search-close, .js-overlay-search', // jquery selector for anything that should close this.
    containerSelector: '.js-header-search', // the container
    classes: ''
};





export default class {

    // Starts here.
    constructor() {
        this.setInitialState();
        this.setCache();
        this.bindEvents();
    }


    // set a state object (for checking different states the mini-cart might have)
    setInitialState() {
        this.state = {
            isOpen: false,
        };
    }

    // cache DOM elements when possible for performance
    setCache () {
        this.cache = {};
        this.cache.container = $(settings.containerSelector);

        // stop if the mini-cart doesn't even exist
        if (this.cache.container.length) {
            this.cache.body = $(document.body); // lots of woocommerce events get fired here.
        }
    }


    // bind the different events that interact with the component
    bindEvents () {

        if (!window.MotionUI) {
            console.warn('animated-searchbar: You need to include MotionUI.');
            return;
        }

        // no use binding if doesn't exist
        if (this.cache.container.length) {

            if (settings.openSelectors) {
                this.cache.body.on('click', settings.openSelectors, this.open.bind(this));
            }

            if (settings.closeSelectors) {
                this.cache.body.on('click', settings.closeSelectors, this.close.bind(this));
            }

        }
    }

    getOverlay() {
        var overlay = $('.js-overlay-search');

        if (!overlay.length) {
            var template = `<div class="overlay overlay--default js-overlay-search"></div>`;
            overlay = $(template).hide();
            this.cache.body.append(overlay);
        }

        return overlay;
    }


    open() {

        if (this.state.isOpen === false) {
            MotionUI.animateIn(this.cache.container, 'slide-in-down fast ease-in', () => {
                // add class is-open class after the animation is done
                this.cache.container.addClass('is-open');
                // focus the input after animation
                this.cache.container.find('input[type=search]').focus();
                this.state.isOpen = true;
            });

            MotionUI.animateIn(this.getOverlay(), 'fade-in fast ease-in ');
        }
    }


    close() {
        if (this.state.isOpen === true) {
            MotionUI.animateOut(this.cache.container, 'fade-out slide-out-down scale-out-up ease-out', () => {
                // remove class is-open class after the animation is done
                this.cache.container.removeClass('is-open');
                this.state.isOpen = false;

            });

            MotionUI.animateOut(this.getOverlay(), 'fade-out fast ease-out ');
        }
    }



}
